<template>
  <div id="app">
    <Loader v-if="!isLoaded" />
    <Header v-if="user.email" :fit20="this._data" :signOut="signOut"></Header>
    <Admin v-if="user.email" :selectTab="selectTab" :fit20="this._data" :saveBlock="saveBlock"
      :cancelEditing="cancelEditing"></Admin>
  </div>
</template>

<script>
import Loader from './components/Loader';
import Header from './components/Header';
import Admin from './components/admin/Admin';
import isEqual from 'lodash/isEqual';
import ISO6391 from 'iso-639-1';

export default {
  name: 'app',
  components: {
    Admin,
    Loader,
    Header,

  },
  data() {
    return {
      languages: ISO6391.getAllNames().map((name) => ({
        name,
        code: ISO6391.getCode(name),
      })),
      urls: null,
      activeCountry: null,
      franchiseCodes: [],
      blockNameToEdit: '',
      blockToEdit: {},
      originalBlock: {},
      blocks: [],
      studios: [],
      studioSites: [],
      countrySites: [],
      franchiseSites: [],
      countries: '',
      activeTab: 'tab_id0',
      baseUrl: window.location.host.includes("localhost") ? "http://localhost:5555" : "",
      storageBaseUrl: window.location.host.includes("localhost") ? "https://storage.googleapis.com/fit20app-4-acctest.appspot.com" : "https://storage.googleapis.com/fit20app-4-acctest.appspot.com",
      isLoaded: false,
      selectedTabHref: "#",
      selectTabId: 'tab_id0',
      user: {},
      users: null,
      originalUsers: null,
      tabs: {
        tab2: {
          active: false,
          action: '',
          exercisesControl: [],
        },
        tab3: {
          active: false,
          action: '',
          exercisesControl: [],
        },
        tab4: {
          active: false,
          action: '',
          exercisesControl: [],
        },
      },
      exercisesControl: {
        tab2: [],
        tab3: [],
        tab4: [],
      },
      saveSessionControl: {
        tab2: [],
        tab3: [],
        tab4: [],
      }
    };
  },
  methods: {
    cancelEditing: function () {
      if (!isEqual(this.blockToEdit, this.originalBlock)) {
        this.blockToEdit = {
          ...this.originalBlock
        };
      }
    },
    saveBlock: async function () {
      if (isEqual(this.blockToEdit, this.originalBlock)) {
        window.alert('There is no changes to publish!');
      } else {
        if (window.confirm('Are you sure you want to publish these changes?')) {
          let updateBlock = await fetch(this.baseUrl + "/api/block/" + this.blockNameToEdit + "/" + this.user.email + "?code=" + this.selectTabId + "&accessToken=" + localStorage.getItem('access_token'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.blockToEdit),
          });
          let updatedBlock = await updateBlock.json();
          this.blockToEdit = JSON.parse(JSON.stringify(updatedBlock));
          this.originalBlock = JSON.parse(JSON.stringify(updatedBlock));
          this.updated = true;
        }
      }
    },
    selectTab(id, tabId) {
      this.selectedTabHref = id;
      if (tabId) {
        this.selectTabId = tabId;
        this.activeTab = tabId;
      }
      this.blockToEdit = {};
      this.blockNameToEdit = '';
    },

    async getRefreshToken() {
      try {
        let refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          const url =
            this.baseUrl + '/api/auth/accessToken?refresh_token=' + refreshToken + `&baseURL=${this.baseUrl.replace(/^https?:\/\//, '')}`;
          const result = await fetch(url);
          const results = await result.json();
          if (results.msg) {
            this.clearLocalStorage();
            this.isLoaded = true;
            window.alert('Authentication Error!');
          } else {
            const base64Url = results.id_token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const decodedToken = JSON.parse(jsonPayload);
            localStorage.setItem('access_token', results.access_token);
            localStorage.setItem('last_token_time', new Date().getTime());
            // to do set a auth token 
          }
        } else {
          this.signOut();
        }
      } catch (err) {
        this.clearLocalStorage();
        this.isLoaded = true;
        window.alert('Authentication Error!');
      }
    },
    signOut() {
      this.clearLocalStorage();
      // const root = window.document.getElementById('app');
      // root.innerHtml += '<img src="https://accounts.google.com/Logout" style="display: none;" />'
      this.isLoaded = false;
      setTimeout(() => {
        this.isLoaded = true;
        window.location.href = "https://www.fit20.com";
      }, 1000); // Redirect back after 2 seconds
    },
    clearLocalStorage() {
      window.onfocus = null;
      window.onload = null;
      window.onclick = null;
      window.ontouchstart = null;
      window.onmousemove = null;
      window.onmousedown = null;
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('last_token_time');
      localStorage.removeItem('user-email');
      localStorage.removeItem('user-picture');
      localStorage.removeItem('user-name');
      localStorage.removeItem('check_time');
    },
    async callback() {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      if (code) {
        try {
          const url =
            this.baseUrl + '/api/auth/accessToken?code=' + code + `&baseURL=${this.baseUrl.replace(/^https?:\/\//, '')}`;
          const result = await fetch(url);
          const results = await result.json();
          if (results.msg) {
            console.error(results.err);
            this.clearLocalStorage();
            this.isLoaded = true;
            alert('Authentication Error!');
          } else {
            const base64Url = results.id_token.split('.')[1];

            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const decodedToken = JSON.parse(jsonPayload);
            localStorage.setItem('user-picture', decodedToken.picture);
            localStorage.setItem('user-name', decodedToken.name);
            localStorage.setItem('user-email', decodedToken.email);
            localStorage.setItem('access_token', results.access_token);
            localStorage.setItem('refresh_token', results.refresh_token);
            localStorage.setItem('last_token_time', new Date().getTime());
            // to do set a auth token 
          }
        } catch (err) {
          this.clearLocalStorage();
          this.isLoaded = true;
          window.alert('Authentication Error!');
        }

      }
      try {
        const userEmail = localStorage.getItem('user-email');
        if (userEmail && !this.user.id) {
          let user = await fetch(this.baseUrl + "/api/users/one/" + userEmail + "?email=" + userEmail + "&accessToken=" + localStorage.getItem('access_token') + "&user=" + userEmail);
          let result = await user.json();
          if (result.msg) {
            this.clearLocalStorage();
            alert(result.msg);
          } else {
            this.user = result;
          }
          if (this.user && this.user.active) {
            let getCountries = await fetch(this.baseUrl + "/api/countries");
            this.countries = await getCountries.json();
            let getBlocks = await fetch(this.baseUrl + "/api/blocks");
            this.blocks = await getBlocks.json();
            this.countries.forEach(country => {
              Object.keys(country.sites).forEach(lang => {
                this.franchiseCodes.push(country.sites[lang][2].code);
              })
            })
            if (this.user.role == 'super_admin') {
              let getUsers = await fetch(this.baseUrl + "/api/users");
              this.users = await getUsers.json();
              this.originalUsers = JSON.parse(JSON.stringify(this.users));
            }
            this.studioSites = this.blocks.filter(item => item.sites.includes('studio'));
            this.countrySites = this.blocks.filter(item => item.sites.includes('country'));
            this.franchiseSites = this.blocks.filter(item => item.sites.includes('franchise'));
            this.isLoaded = true;
          } else {
            // throw permission denied
            this.isLoaded = true;
            window.alert('inactive user');
          }
        }
      } catch (err) {
        console.log(err);
        this.clearLocalStorage();
        this.isLoaded = true;
        alert('Authentication Error!');
      }
    },
  },

  mounted: function () {

  },
  async created() {
    const vm = this;
    if (!window.location.host.includes("localhost")) {
      this.baseUrl = window.location.protocol + '//' + window.location.host;
    }
    try {
      // To do: make the the client_id dynamic 
      let client_id = '103079258064-7qgliijq6gr03r6jhq87on3vhnq5uaep.apps.googleusercontent.com';
      // code model
      let redirect_uri = window.location.protocol + '//' + window.location.host;
      let client = window.google.accounts.oauth2.initCodeClient({
        client_id: client_id,
        scope: 'profile email',
        ux_mode: 'redirect',
        redirect_uri: redirect_uri,
        access_type: 'offline',
      });
      await this.callback();
      if (window.location.search != '') {
        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      }
      const token = localStorage.getItem('user-email');
      if (!token) {
        client.requestCode();
      } else {
        this.getRefreshToken();
      }

      if (this.user.email) {
        function inactivityTime() {
          var time;
          // events
          let resetTime;
          resetTime = () => {
            let user = localStorage.getItem('user-email');
            let accessToken = localStorage.getItem('access_token');
            let refreshToken = localStorage.getItem('refresh_token');
            if (!user && !accessToken && !refreshToken) {
              resetTime = null;
              vm.clearLocalStorage();
              alert('you logged out');
              window.location.href = window.location.origin;
            }
            let checkTime = localStorage.getItem('check_time');
            let lastAccessToken = localStorage.getItem('last_token_time');
            if (!checkTime) {
              localStorage.setItem('check_time', new Date().getTime());
            }
            // force to logout if the user inactive for more than 58 min
            else if (new Date().getTime() - checkTime > (60 * 60 * 1000)) {
              vm.signOut();
            }
            else {
              localStorage.setItem('check_time', new Date().getTime());
            }
            clearTimeout(time);
            time = setTimeout(vm.signOut, 58 * 60 * 1000);
          }
          window.onfocus = resetTime;
          window.onload = resetTime;
          window.onclick = resetTime;
          window.onkeypress = resetTime;
          window.ontouchstart = resetTime;
          window.onmousemove = resetTime;
          window.onmousedown = resetTime;
          window.addEventListener('scroll', resetTime, true);
          resetTime();
        };
        inactivityTime();
        // ask for refresh token every hour
        setInterval(this.getRefreshToken, 59 * 59 * 1000);

      }
    } catch (err) {
      this.clearLocalStorage();
      console.log(err);
      this.errors.push('Authentication in app.js ' + formattedDateTime());
      this.errors.push(err.message + " " + formattedDateTime());
      window.alert('Authentication Error!');
    }
  },
  watch: {
    blockToEdit: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        if (isEqual(newVal, this.originalBlock)) {
          $('#cancelUser').removeClass("cancel-btn-active");
          $('#saveUser').removeClass("save-btn-active");
          $('#cancelUser2').removeClass("cancel-btn-active");
          $('#saveUser2').removeClass("save-btn-active");
          $('#cancelUser3').removeClass("cancel-btn-active");
          $('#saveUser3').removeClass("save-btn-active");
        } else {
          if (!$('#cancelUser').hasClass('cancel-btn-active')) {
            $('#cancelUser').addClass("cancel-btn-active");
            $('#saveUser').addClass("save-btn-active");
            $('#cancelUser2').addClass("cancel-btn-active");
            $('#saveUser2').addClass("save-btn-active");
            $('#cancelUser3').addClass("cancel-btn-active");
            $('#saveUser3').addClass("save-btn-active");
          }
        }
      }
    },
  }
};
</script>

<style>
:root {
  --fit20-green: #92d400;
  --fit20-gray: #616365;
  --fit20-light-gray: #22222280;
  --fit20-lighter-gray: #0000002f;
  --fit20-blue: #009EFB;
  --fit20-light-blue: #009FE380;
  --fit20-lighter-blue: #009FE322;
  --fit20-pink: #e5007d;
  --fit20-orang: #FC802D;

}

.orange {
  color: var(--fit20-orang);
}

@font-face {
  font-family: 'VAG light';
  src: url('./assets/fonts/rond-light.woff2') format('woff2');
  font-display: swap;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  /* overflow-x: hidden; */
  scroll-behavior: smooth;
  /* overflow: hidden; */
  font-family: 'VAG light', 'Courier New', Courier, monospace;
}

body {
  min-width: 400px;
  margin: 0 auto;
  animation: appear-main 1s;
}

.text-primary {
  color: var(--fit20-green);
}

.text-secondary {
  color: var(--fit20-blue);
}

.text-body {
  color: var(--fit20-gray);
}

.studios {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: calc(100% - 200px);
  /* Adjust as needed */
  overflow: auto;
}

.studio-card {
  margin: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  width: calc(100% / 3 - 10px);
  height: 85px;
  border-radius: 10px;

  /* dding-left: 5px;pa */
}

.studio-card a {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  color: var(--fit20-blue) !important;
}

.card-div {
  height: 100%;
  padding: 6px;
}

.card-div img {
  width: 35%;
  /* padding: 8px; */
  border-radius: 10px;
  max-height: 70px;
  max-width: 70px;

}

.item-name {
  margin-top: 3px;
  margin-left: 5px;
  width: 60%;
  word-break: break-word;
}

.pointer {
  cursor: pointer;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.active {
  display: block !important;
}

.show {
  opacity: 1 !important;
}

.fade {
  opacity: 0;
}

.display-none {
  display: none;
}

.form-container input,
.form-container select,
.form-container textarea {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 5px;
  padding: 3px 5px;
  width: 95%;
  background-color: white;
  color: var(--fit20-gray);
}

.array-links {
  width: 100% !important;
}

.field-sec label {
  /* padding: 10px 0; */
  color: var(--fit20-gray);
}

.inputFileHidden {
  position: relative;
  overflow: hidden;
}

.inputFileHidden input[type='file'] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 50px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}

.popup-overlay {
  overflow: scroll;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

span.img-container {
  display: inline-block;
  position: relative;
}

.img-ico {
  position: absolute;
  bottom: 15px;
  right: 5px;
  width: 40px;
}

.btn-container {
  text-align: right;
  margin-top: 10px;
  margin-right: 15px;
}

.fit20-btn {
  padding: 1px 15px;
  border-radius: 5px;
  cursor: pointer;
}

.save-btn-active {
  color: white !important;
  background-color: var(--fit20-blue) !important;
  transition: all 1s;
  margin-left: 10px;
}

.cancel-btn-active {
  color: white !important;
  background-color: var(--fit20-blue) !important;
  transition: all 1s;
}

.save-btn-disable {
  color: var(--fit20-blue);
  border: solid 1px var(--fit20-blue);
  transition: all 1s;
  margin-left: 10px;
}

.cancel-btn-disable {
  color: var(--fit20-blue);
  border: solid 1px var(--fit20-blue);

  transition: all 1s;
}

.dropdown-container {
  position: relative;
  display: block;
  background-color: white;
  z-index: 999999999999999999;
}

.dropdown-options {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
}

.dropdown-option {
  padding: 8px;
  cursor: pointer;
}

.switch-btn {
  display: flex;
  justify-content: space-between;
  align-items: end;
}

.custom-select {
  position: relative;
  display: inline-block;
}

.custom-select select {
  display: none;
}

.select-selected {
  background-color: #f1f1f1;
  padding: 5px 10px;
  border: 1px solid #ccc;
  cursor: pointer;
}

.select-items div:hover,
.same-as-selected {
  background-color: #ddd;
}

.select-items {
  position: absolute;
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  z-index: 999;
}

.popup-content {
  background-color: white;
  width: 85%;
  padding: 0px 0px 20px 0px;
  border-radius: 10px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
}

.popup-title {
  background-color: var(--fit20-green);
  color: white;
  justify-content: space-between;
  padding: 5px 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

@keyframes appear-main {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

ul {
  list-style: none;
}

a:focus,
a:visited,
a:link,
a:hover {
  text-decoration: none;
}

@media only screen and (min-width: 770px) {}
</style>
